export default __webpack_public_path__ + "static/media/generalAssemblyLogo.6e9efafd.png";